let hasPageResizeReloadBinding = false;
let pageResizeDebounce;
let lastViewportWidth = window.innerWidth;

function isIpadDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /ipad/.test(userAgent) || (/macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);
}

function isDesktopViewport() {
  // Keep page reload fallback to desktop-like input devices only.
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

function bindDesktopResizePageReload() {
  if (hasPageResizeReloadBinding) {
    return;
  }

  hasPageResizeReloadBinding = true;
  lastViewportWidth = window.innerWidth;

  jQuery(window)
    .off('resize.lazyLoadPageReload')
    .on('resize.lazyLoadPageReload', function() {
      const currentViewportWidth = window.innerWidth;
      if (currentViewportWidth === lastViewportWidth) {
        return;
      }

      lastViewportWidth = currentViewportWidth;

      if (!isDesktopViewport()) {
        return;
      }

      clearTimeout(pageResizeDebounce);
      pageResizeDebounce = setTimeout(function() {
        window.location.reload();
      }, 300);
    });
}

export default function initLazyLoad() {
  const $iframeHolders = jQuery('.bg-stretch:has(iframe)');

  if ($iframeHolders.length > 0) {
    bindDesktopResizePageReload();
  }

	$iframeHolders.each(function(_, holder) {
		var $iframe = jQuery(this).find('iframe');

		var observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					checkAndLoadIframe();

					observer.unobserve(entry.target);
				}
			});
		});

		observer.observe(holder);

    function getPreferredSource() {
      const isIpad = isIpadDevice();
      const portraitSource = $iframe.data('src-portrait');
      const landscapeSource = $iframe.data('src');
      const hasScreenOrientation = window.screen.orientation && ["portrait-secondary", "portrait-primary"].includes(window.screen.orientation.type);
      const matchesPortraitMedia = window.matchMedia("(orientation: portrait)").matches;
      const isPortrait = hasScreenOrientation || matchesPortraitMedia;

      return ((isPortrait || isIpad) && portraitSource) ? portraitSource : landscapeSource;
    }

    function checkAndLoadIframe() {
      const cookiesRequired = !!$iframe.data('cookiesRequired');
      const cookiesAccepted = !!(window.ccc && window.ccc.functional);
      const canLoadVideo = !cookiesRequired || (cookiesRequired && cookiesAccepted);
      if (canLoadVideo) {
        loadIframe();
      } else {
        setTimeout(checkAndLoadIframe, 500);
      }
    }

    function handleIframeLoaded() {
      $iframe.addClass('loaded');
    }

    function loadIframe() {
      $iframe
        .off('load.lazyLoadIframe')
        .one('load.lazyLoadIframe', function() {
          handleIframeLoaded();
        });

      const preferredSource = getPreferredSource();
      const existingSource = $iframe.attr('src');

      // Pick the best source before assigning src, so mobile avoids loading desktop first.
      if (preferredSource && preferredSource !== existingSource) {
        $iframe.attr('src', preferredSource);
      } else {
        handleIframeLoaded();
      }
    }
	});
}
